import * as React from 'react';
import { IDataEntity } from '../../models';
import { safe, toDisplay, getGroupedRows, isNullOrUndefined } from "../../utils";
import * as moment from "moment";
import { NumberFormat } from "../../assets/NumberFormat/NumberFormat";
import { IPageProperties, IExplorerProperties } from "../../models";
import { ArrowIndicator, Disclaimer } from "../../assets";
import { ExplorerTabDailyPrices, ExplorerTabPerformance, ExplorerTabCharges, ExplorerTabYield } from "../FundExplorerTabs";
const FaAngleDown = require('react-icons/lib/fa/angle-down');
const styles = require('../FundPages/Fundpages.pcss');
const internalStyles = require('./ExplorerPDF.pcss');
const FaPDF = require('react-icons/lib/fa/file-pdf-o');
const FaDownload = require('react-icons/lib/fa/download');
const overrideStyles = require('./overrides/arrowIndicatorOverride.pcss');


interface IState {
    visible: boolean;
}

export class ExplorerPDF extends React.Component<IPageProperties & IExplorerProperties, IState>{
    disclaimerContent = null;
    constructor(props) {
        super(props);
        this.getTableComponent = this.getTableComponent.bind(this);
        this.getHeading = this.getHeading.bind(this);
    }
    getHeading() {
        let { appParams } = this.props;
        let heading = "";
        switch (appParams.tab) {
            case "dailyPrices":
                heading = "Daily Prices";
                break;
            case "performance":
                heading = "Performance";
                break;
            case "fundCharges":
                heading = "Fund Charges";
                break;
            default: null;
        }
        return heading;
    }

    getMStarDate(funds) {
        let date: string;
        for (let fund of funds) {
            let checkdate;
            for (let share of fund.shareClasses) {
                checkdate = safe(() => share.statisticsMapping.morning_star_rating.date, null);
                if (!isNullOrUndefined(checkdate)) {
                    date = checkdate;
                    break;
                }
            }
            if (!isNullOrUndefined(checkdate)) {
                break;
            }
        }
        return date;
    }

    getTableComponent() {
        let { funds, toggleFund, editWatchlist, watchlist, toggleShareClass, toggleShareClassPerformance, toggleAllFunds, isLoading, appParams, sorting, changeSortOrder, infiniteScroll, execInfiniteScroll, disclaimers } = this.props;
        let groupedRows = getGroupedRows(funds);
        let { clienttype, productrange } = appParams;
        const showMStarOverall = clienttype === "pri" || clienttype === "cha";
        let response;
        if (appParams.tab === 'dailyPrices') {
            response = (
                <ExplorerTabDailyPrices
                    funds={ funds }
                    infiniteScroll={ infiniteScroll }
                    execInfiniteScroll={ execInfiniteScroll }
                    watchlist={ watchlist }
                    editWatchlist={ editWatchlist }
                    appParams={ appParams }
                    isLoading={ isLoading }
                    toggleFund={ toggleFund }
                    toggleShareClass={ toggleShareClass }
                    toggleShareClassPerformance={ toggleShareClassPerformance }
                    disclaimers={ disclaimers }
                    groupedRows={ groupedRows }>
                </ExplorerTabDailyPrices>
            );
            this.disclaimerContent = <Disclaimer appParams={ appParams } disclaimer={ disclaimers["daily_prices_disclaimer"] } />;
        }
        else if (appParams.tab === 'performance') {
            response = (
                <ExplorerTabPerformance
                    funds={ funds }
                    infiniteScroll={ infiniteScroll }
                    execInfiniteScroll={ execInfiniteScroll }
                    watchlist={ watchlist }
                    editWatchlist={ editWatchlist }
                    appParams={ appParams }
                    isLoading={ isLoading }
                    toggleFund={ toggleFund }
                    toggleShareClass={ toggleShareClass }
                    toggleShareClassPerformance={ toggleShareClassPerformance }
                    disclaimers={ disclaimers }
                    groupedRows={ groupedRows }>
                </ExplorerTabPerformance>
            );
            this.disclaimerContent = (
                <div className="">
                    <Disclaimer appParams={ appParams } disclaimer={ disclaimers["performance_disclaimer"] } hideStatic={ true } />
                    <Disclaimer appParams={ appParams } date={ this.getMStarDate(funds.values) } disclaimer={ disclaimers[(showMStarOverall ? "ratings_ratingsmorningstaroverall" : "ratings_ratingsmorningstaroverallandanalyst")] } />
                </div>
            );

        }
        else if (appParams.tab === 'fundCharges') {
            response = (
                <ExplorerTabCharges
                    funds={ funds }
                    infiniteScroll={ infiniteScroll }
                    execInfiniteScroll={ execInfiniteScroll }
                    watchlist={ watchlist }
                    editWatchlist={ editWatchlist }
                    appParams={ appParams }
                    isLoading={ isLoading }
                    toggleFund={ toggleFund }
                    toggleShareClass={ toggleShareClass }
                    toggleShareClassPerformance={ toggleShareClassPerformance }
                    disclaimers={ disclaimers }
                    groupedRows={ groupedRows }>
                </ExplorerTabCharges>
            );
            this.disclaimerContent = <Disclaimer appParams={ appParams } disclaimer={ disclaimers["fund_charges_disclaimer"] } />;
        }
        return response;
    }

    render() {
        let { funds, toggleFund, editWatchlist, watchlist, toggleShareClass, toggleShareClassPerformance, toggleAllFunds, isLoading, appParams, sorting, changeSortOrder, infiniteScroll, execInfiniteScroll, disclaimers } = this.props;
        let heading = this.getHeading();
        let tableComponent = this.getTableComponent();
        return (
            <div className={ internalStyles.printable }>
                <table>
                    <thead>
                        <tr className={ internalStyles.hackHeader }>
                            <th>
                                <div className={ internalStyles.headerRow }>
                                    <div className={ internalStyles.logoHolder }>
                                        <img style={ { width: 'auto', height: '80px' } } src={ require('../../images/M&G_Investments.jpg') } />
                                    </div>
                                    <div className={ internalStyles.PageTitle }>
                                        <h1>{ heading }</h1>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                { tableComponent }
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className={ internalStyles.printDisclaimer }>
                    { this.disclaimerContent  }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/ExplorerPDF/ExplorerPDF.tsx